import api from '@/apis/di/activityAPI.js';
import {usefilterActionCombo} from './filterActionCombo.js';

// Combo grid CTMT
export const useActivityComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const {extendFilter} = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onActivityComboboxLoadData = (payload, row, column, custom) => {
    payload.sort = 'activity_code';
    let ors = [{Field: 'inactive', Operator: 'NULL'}];
    let extend = [{Field: 'inactive', Value: false, Ors: ors}];
    payload.filter = extendFilter(payload.filter, extend);
    payload.columns += ',parent_id,activity_code, grade';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // func call api lấy dữ liệu combo
  const onActivityComboboxLoadAllData = (payload, row, column, custom) => {
    payload.sort = 'misa_code_id, activity_code';
    payload.columns += ',parent_id,activity_code';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // config columns combo
  const activityComboConfig = {
    data: comboboxDataRemote,
    displayField: 'activity_name',
    valueField: 'activity_id',
    queryMode: 'remote',
    dropdownWidth: 300,
    comboboxLoadData: onActivityComboboxLoadData,
  };

  return {
    activityComboConfig,
    onActivityComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
    onActivityComboboxLoadAllData,
  };
};
